"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
exports.default = (react_1.default.createElement("path", { d: "M12 9L12.5303 8.46967C12.2374 8.17678 11.7626 8.17678 11.4697 8.46967L12 9ZM18.5303 14.4697L12.5303 8.46967L11.4697 9.53033L17.4697 15.5303L18.5303 14.4697ZM11.4697 8.46967L5.46967 14.4697L6.53033 15.5303L12.5303 9.53033L11.4697 8.46967Z", fill: "currentColor" }));
